import Toaster from "../classes/Toaster";

export default function () {
	const toaster = document.querySelector('.js-toaster');

	if (!toaster) {
		return;
	}

	window.toaster = new Toaster(toaster);
};